import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTestResultIconModule } from '../data-test-result-icon/data-test-result-icon.module';
import { DataTestResultCellRendererComponent } from './data-test-result-cell-renderer.component';

@NgModule({
  declarations: [DataTestResultCellRendererComponent],
  imports: [CommonModule, DataTestResultIconModule],
})
export class DataTestResultCellRendererModule {}
